<template>
    <div class="addressList">
        <myNav myTitle="我的地址"><span @click="returnBack">确定</span></myNav>
        <van-address-list
        v-model="chosenAddressId"
        default-tag-text="默认"
        :list="alladress"
        @add="onAdd"
        @edit="onEdit"/>
    </div>
</template>

<script>
import myNav from "./allNav"
export default {
    components:{
        myNav
    },
    data(){
        return{
            alladress:[], //地址
            chosenAddressId:""
        }
    },
    created(){
        this.obtailAdress();
    },
    methods:{
        // 获取地址 
        obtailAdress(){
            // "mmall/shipping/selectUserById?userId="+window.localStorage.useId
            this.$http.get(this.javalinkTwo +"mmall/shipping/selectShippingByadmin?typeId="+this.wenOrRong)
            .then(res => {
                console.log(res.data);
                if (res.data.success){
                    var data=res.data.data;
                    for(let i=0;i<data.length;i++){
                        data[i].address=data[i].receiverPrivince+data[i].receiverCity+data[i].receiverDistrict+data[i].receiverAddress;
                        data[i].isDefault=data[i].checked==1?true:false;
                    }
                    var changeData=JSON.stringify(data);
                    this.alladress=JSON.parse(changeData.replace(/receiverName/g,'name').replace(/receiverMobile/g,'tel'));
                    this.chosenAddressId=this.alladress[this.$route.query.index].id;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 新增地址
        onAdd(){
            this.$router.push({path:"/harvestAddress"});
        },
        // 编辑地址
        onEdit(item,index){
            this.$router.push({path:"/harvestAddress",query:{
                id:item.id,
                index:index
            }});
        },
        // 返回上一层
        returnBack(){
            for(var i=0;i<this.alladress.length;i++){
                if(this.chosenAddressId==this.alladress[i].id){
                    this.Event.$emit('myBack',i);
                    break;
                }
            }
            if(i==this.alladress.length&&this.alladress.length>0){ //没用数据则匹配到第一个
                this.Event.$emit('myBack',0);
            }
            this.$router.go(-1);
        }
    }
}
</script>

<style lang="less" scoped>
    .van-address-list__bottom{
        display: none;
    }
    .van-address-item__edit{
        display: none;
    }
    .addressList{
        width: 100%;
        height: 100%;
    }
    .van-address-list{
        height:calc(100% - 64px);
    }
</style>